import { FC } from 'react';
import ReactDOM from 'react-dom/client';
import { useIntl } from 'react-intl';

import { PasswordResetGlobalStyles } from './components/PasswordResetGlobalStyles';
import { PasswordResetView } from './components/PasswordResetView';
import { translations } from './i18n';
import * as styles from './styles';

import { AppProviders } from '../../components/providers/AppProviders';
import { AuthPageContainer } from '../../modules/auth';
import { getMediaUrl } from '../../shared/config';

const PasswordResetPage: FC = () => {
  const intl = useIntl();

  return (
    <AuthPageContainer
      title={intl.formatMessage(translations.pageTitle)}
      subtitle={intl.formatMessage(translations.pageSubtitle)}
      leftContentTitle={intl.formatMessage(translations.pageLeftTitle)}
      leftContentBg="#6684A2"
      leftContentImageSrc={getMediaUrl('/registration/box-2-cropped.webp')}
      leftContentImagePlacement="right"
      backButtonHref="/"
      sx={styles.root}
    >
      <PasswordResetView />
    </AuthPageContainer>
  );
};

const rootElement = document.getElementById('password-reset-page-root');

if (!rootElement) {
  throw new Error('Cannot find #password-reset-page-root element');
}

ReactDOM.createRoot(rootElement).render(
  <AppProviders>
    <PasswordResetGlobalStyles />
    <PasswordResetPage />
  </AppProviders>,
);
